import { css, theme } from '@kui-shared/styles';

const TextStyle = css({
  $$fontFamily: theme.fonts.nvidiaSans,
  $$fontSize: theme.fontSizes.md,
  $$fontWeight: theme.fontWeights.regular,
  $$lineHeight: theme.lineHeights.text,
  fontFamily: '$$fontFamily',
  fontSize: '$$fontSize',
  fontWeight: '$$fontWeight',
  lineHeight: '$$lineHeight',
  // NOTE: intentionally incomplete list of common elements.
  variants: {
    variant: {
      h1: {
        $$fontSize: theme.fontSizes.xxl,
        $$fontWeight: theme.fontWeights.medium,
        $$lineHeight: theme.lineHeights.heading
      },
      h2: {
        $$fontSize: theme.fontSizes.xl,
        $$fontWeight: theme.fontWeights.medium,
        $$lineHeight: theme.lineHeights.heading
      },
      h3: {
        $$fontSize: theme.fontSizes.lg,
        $$fontWeight: theme.fontWeights.medium,
        $$lineHeight: theme.lineHeights.heading
      },
      h4: {
        $$fontSize: theme.fontSizes.ml,
        $$fontWeight: theme.fontWeights.medium,
        $$lineHeight: theme.lineHeights.heading
      },
      h5: {
        $$fontSize: theme.fontSizes.md,
        $$fontWeight: theme.fontWeights.medium,
        $$lineHeight: theme.lineHeights.heading
      },
      h6: {
        $$fontSize: theme.fontSizes.ms,
        $$fontWeight: theme.fontWeights.medium,
        $$lineHeight: theme.lineHeights.heading
      },
      helper: {
        $$fontSize: theme.fontSizes.sm,
        $$fontWeight: theme.fontWeights.regular,
        $$lineHeight: theme.lineHeights.text,
        color: theme.colors.inputFgDefault
      },
      label: {
        $$fontSize: theme.fontSizes.sm,
        $$fontWeight: theme.fontWeights.medium,
        $$lineHeight: theme.lineHeights.text,
        color: theme.colors.inputFgLabel
      },
      small: {
        $$fontSize: theme.fontSizes.ms
      },
      strong: {
        $$fontWeight: theme.fontWeights.bold
      }
    }
  }
});

/**
 * TestIDs
 */
const TextTestIDs = {
  Text: 'kui-text'
};
/**
 * Defaults
 */
const TextDefaults = {
  css: {},
  variant: 'small'
};

export { TextDefaults, TextStyle, TextTestIDs };
